













































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import SwitchButton from "@/components/SwitchButton.vue";
import SelectOption from "@/common/ui/presenters/select-option";
import {
  saveConstructionTask,
  SaveConstructionTaskCommand
} from "../../api/construction-task-api";
import { Construction, getConstruction } from "../../api/construction-api";

@Component({
  components: {
    SwitchButton
  }
})
export default class ConstructionTaskForm extends Vue {
  @Prop({ default: () => {} })
  defaultValues!: Partial<SaveConstructionTaskCommand>;

  data: SaveConstructionTaskCommand = {
    name: "",
    shortName: "",
    alignment: "0",
    clear: "0",
    serviceTaskTypeId: "0"
  };
  error = "";
  formStatus: "" | "progressing" = "";

  constructions: Construction[] = [];

  // TODO: 共通化する
  alignmentOptions: SelectOption[] = [
    { text: "左", value: "1" },
    { text: "中央", value: "2" },
    { text: "右", value: "3" },
    { text: "非表示", value: "0" }
  ];

  clearOptions = [
    {
      text: "",
      value: ""
    },
    {
      text: "チェック及び色変え",
      value: "1"
    },
    {
      text: "メモ記載",
      value: "2"
    }
  ];

  get templateOptions(): SelectOption[] {
    return this.$store.getters.serviceTaskTypeOptions.concat([
      { text: "非表示", value: "0" }
    ]);
  }

  get constructionOptions(): SelectOption[] {
    return this.constructions.map(c => ({
      text: c.name,
      value: c.id
    }));
  }

  public created() {
    this.initConstruction();
  }

  public async submit() {
    this.error = "";
    try {
      await saveConstructionTask(this.data);
      this.$emit("submit");
    } catch (e) {
      this.error = String(e);
    }
  }

  @Watch("defaultValues", { immediate: true })
  onDefaultValuesChanged(defaultValues: Partial<SaveConstructionTaskCommand>) {
    this.data = { ...this.data, ...defaultValues };
  }

  private async initConstruction() {
    this.constructions = await getConstruction();
  }
}
